module.exports = __webpack_public_path__ + "static/img/banner.f81b39e3.png";